import { getUsuariosPermissoes } from "@/api/permissoes/users_permissoes.js";

export default {
  data: () => ({
    usersPermissions: [],
  }),
  methods: {
    getUsersPermissions() {
      getUsuariosPermissoes()
        .then((response) => {
          this.usersPermissions = response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    checkUserPermissions(id, bits) {
      let isEqual = {
        visualizar: false,
        adicionar: false,
        editar: false,
        deletar: false,
        imprimir: false,
        importar: false,
        exportar: false,
      };

      this.usersPermissions.forEach((element) => {
        if (id === element.permissao_id) {
          if (
            this.checkVisualizar(bits) === false &&
            this.checkVisualizar(element.bits)
          ) {
            isEqual.visualizar = true;
          }
          if (
            this.checkAdicionar(bits) === false &&
            this.checkAdicionar(element.bits)
          ) {
            isEqual.adicionar = true;
          }
          if (
            this.checkEditar(bits) === false &&
            this.checkEditar(element.bits)
          ) {
            isEqual = true;
          }
          if (
            this.checkDeletar(bits) === false &&
            this.checkDeletar(element.bits)
          ) {
            isEqual.deletar = true;
          }
          if (
            this.checkImprimir(bits) === false &&
            this.checkImprimir(element.bits)
          ) {
            isEqual.imprimir = true;
          }

          if (
            this.checkImportar(bits) === false &&
            this.checkImportar(element.bits)
          ) {
            isEqual.importar = true;
          }
          if (
            this.checkExportar(bits) === false &&
            this.checkExportar(element.bits)
          ) {
            isEqual.exportar = true;
          }

        }
      });
      return isEqual;
    },
  },
  mounted() {
    this.getUsersPermissions();
  },
};
